import { createContext, useContext, useState, ReactNode } from 'react';
import { Locale, defaultLocale } from './messages';

interface LocaleContextType {
	locale: Locale;
	setLocale: (locale: Locale) => void;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

export function LocaleProvider({ children }: { children: ReactNode }) {
	const [locale, setLocale] = useState<Locale>(defaultLocale);

	return <LocaleContext.Provider value={{ locale, setLocale }}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
	const context = useContext(LocaleContext);
	if (!context) {
		throw new Error('useLocale must be used within LocaleProvider');
	}
	return context;
}
